<div *ngIf="cardsMasteredCount != null && totalCardsCount != null" class="open-widget">
  <div class="header">
    <tabler-icon name="trending-up"></tabler-icon>
    <span>Lernfortschritt</span>
  </div>
  <div class="content">
    <span class="open-cards-count">{{ cardsMasteredCount / totalCardsCount | percent: '1.0'}}</span>
    <span class="total-cards-count">gemeistert</span>
  </div>
  <app-progress-bar *ngIf="!showButtonToSmartRepetition" [progress]="(cardsMasteredCount == 0 && totalCardsCount == 0) ? 0 : (cardsMasteredCount! / totalCardsCount!) * 100" [color]="'success'"></app-progress-bar>
</div>